import { render, staticRenderFns } from "./ModalPaymentMethod.vue?vue&type=template&id=5cf78921&"
import script from "./ModalPaymentMethod.vue?vue&type=script&lang=js&"
export * from "./ModalPaymentMethod.vue?vue&type=script&lang=js&"
import style0 from "./ModalPaymentMethod.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports